<script lang="ts">
  import AnimatedIcon from "../../icon/v1/AnimatedIcon.svelte";
  import type { Props } from "./IconButtonV4.types.ts";

  let { icon }: Props = $props();
</script>

<slot />
<AnimatedIcon type={icon} />

<style lang="scss">
  :global {
    svg {
      position: absolute;
      inset: 0;
      margin: auto;
      overflow: visible;
      width: var(--_icon-size);
      height: var(--_icon-size);
      color: var(--_icon-color);
    }
  }

  :host([loading]) :global(svg) {
    display: none;
  }
</style>
